import { Inject, Injectable } from '@angular/core';
import { IUnitOfWorkFactory } from 'src/app/common/contracts/unit-of-work/unit-of-work-factory';
import { UnitOfWorkFactory } from 'src/app/common/unit-of-work/unit-of-work-factory';
import { ProductGroupDto } from 'src/app/shared/models/article/product-group-dto.model';

import { ProductGroupDB } from '../../common/repository/databases';
import { WorkItem } from '../work-item';

@Injectable({ providedIn: 'root' })
export class ProductGroupWorkItem extends WorkItem<ProductGroupDto> {
  constructor(@Inject(UnitOfWorkFactory) unitOfWorkFactory: IUnitOfWorkFactory) {
    super(unitOfWorkFactory);
  }
  get name(): string {
    return 'ProductGroupWorkItem';
  }
  get database(): string {
    return ProductGroupDB;
  }
}
